import React, { useEffect } from "react";
import { RootState } from "../../store";
import { connect } from "react-redux";
import { Input } from "../../components/common/Input";
import { REGEXES } from "../../constants/common";
import { useForm } from "react-hook-form";
import { Button } from "../../components/common/Button";
import { UserActionCreator } from "../../store/userActions";
import {
    selectResetPasswordError,
    selectResetPasswordErrorMessage,
    selectResetPasswordPending,
    selectResetPasswordSuccess,
} from "../../store/selectors";
import { Link } from "react-router-dom";
import { ReactComponent as Chevron } from "../../assets/icons/chevron.svg";

const _ResetPassword = ({
                            pending,
                            error,
                            errorMessage,
                            success,
                            resetPassword,
                        }) => {
    const {
        register,
        handleSubmit,
        setError,
        formState: { errors },
    } = useForm({ mode: "onChange" });

    const emailError = errors.email?.message;

    const onSubmit = (data) => {
        resetPassword(data);
    };

    useEffect(() => {
        if (error && errorMessage) {
            setError("email", { message: errorMessage });
        }
    }, [error, errorMessage, setError]);

    if (success) {
        return (
            <div className="px-5 mt-5 lg:w-[400px] lg:mx-auto">
                <h2 className="text-2xl font-semibold">Пароль обновлен</h2>
                <div className="mt-5 mb-5 text-sm text-[#818c99]">
                    мы сгенерировали и отправили новый пароль на ваш e-mail
                </div>
                <a
                    href="/"
                    className="block text-center font-semibold text-[#c06198]"
                >
                    продолжить
                </a>
            </div>
        );
    }

    return (
        <>
            <Link
                className="flex items-center gap-1 px-5 mt-5 mb-4 text-sm text-gray-700 no-underline"
                to="/"
            >
                <Chevron className="w-4 h-4 rotate-180" />
                назад
            </Link>

            <div className="px-5 lg:w-[400px] lg:mx-auto">
                <h2 className="text-2xl font-semibold">Сброс пароля</h2>
                <div className="mt-5 mb-5 text-sm text-[#818c99]">
                    Введите адрес электронной почты, привязанный к вашей учетной записи.
                    Мы сгенерируем и отправим на него новый пароль.
                </div>

                <form
                    onSubmit={handleSubmit(onSubmit)}
                    className="flex flex-col gap-6 bg-white p-4 rounded-xl shadow-[0_2px_24px_rgba(0,0,0,0.08)]"
                >
                    <div>
                        <Input
                            register={register("email", {
                                required: { message: "введите e-mail", value: true },
                                pattern: {
                                    message: "некорректный e-mail",
                                    value: REGEXES.email,
                                },
                            })}
                            name="email"
                            type="email"
                            placeholder="e-mail"
                            label="введите e-mail"
                            error={!!emailError}
                            errorMessage={emailError}
                        />
                    </div>

                    <div>
                        <Button pending={pending} text="отправить" />
                    </div>
                </form>
            </div>
        </>
    );
};

const mapStateToProps = (state: RootState) => ({
    pending: selectResetPasswordPending(state),
    error: selectResetPasswordError(state),
    errorMessage: selectResetPasswordErrorMessage(state),
    success: selectResetPasswordSuccess(state),
});

const mapDispatchToProps = {
    resetPassword: UserActionCreator.resetPassword,
};

export const ResetPassword = connect(
    mapStateToProps,
    mapDispatchToProps,
)(_ResetPassword);
